import { smallLabelTypographicStyle } from "@/lib/styles/helpers";
import styled from "styled-components";

export const Container = styled.div`
  ${smallLabelTypographicStyle}
  flex: 1 1 100%;
  order: 2;

  margin: 2.5rem 0;

  ${({ theme }) => theme.mediaQueries.laptop} {
    order: 3;
    margin-bottom: 0;
  }
`;
